import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { products } from "../data/projects";
import PageHero from "../widgets/PageHero";
import ProductFeature from "../widgets/ProductFeature";
import CtaBand from "../widgets/CtaBand";

export function Products() {
    const { t } = useTranslation("Common");
    return (
        <>
            <Helmet>
                <title>{t("productsPage.meta.title")}</title>
                <meta name="description" content={t("productsPage.meta.description")} data-rh="true" />
                <link rel="canonical" href="https://oxide-digital.com/products" />
            </Helmet>
            <PageHero eyebrow={t("productsPage.hero.eyebrow")} title={t("productsPage.hero.title")} lead={t("productsPage.hero.lead")} />
            {products.map((project, i) => (
                <ProductFeature key={project.id} project={project} reverse={i % 2 === 1} />
            ))}
            <CtaBand />
        </>
    );
}
